module.exports = __webpack_public_path__ + "static/img/chuck-academy.6844187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chuck-academy.jpg
// module id = ySA6
// module chunks = 0